import React from 'react';
import { useParams } from 'react-router-dom';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import DealViewWrapper from '@/components/views/DealView/DealViewWrapper';
import { Box } from '@mui/material';

const ViewDealPage = () => {
	const { dealId } = useParams();

	// Keyed so switching deals (e.g. via global search) remounts the view instead of showing the old deal's data.
	return (
		<AuthenticatedPageLayout>
			<Box pb={3}>
				<DealViewWrapper key={dealId} />
			</Box>
		</AuthenticatedPageLayout>
	);
};

export default ViewDealPage;
